export class ApiError extends Error {
  code: string;
  status: number;

  constructor(message: string, code: string, status: number) {
    super(message);
    this.code = code;
    this.status = status;
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch(path, {
    ...options,
    headers: {
      "content-type": "application/json",
      ...(options.headers ?? {})
    }
  });
  const data = (await res.json().catch(() => ({}))) as { error?: { message: string; code: string } };
  if (!res.ok) {
    throw new ApiError(data.error?.message ?? "请求失败", data.error?.code ?? "request_error", res.status);
  }
  return data as T;
}

export async function streamApi(
  path: string,
  body: unknown,
  handlers: {
    onDelta: (content: string) => void;
    onDone: () => void;
    onError: (message: string) => void;
  }
) {
  const res = await fetch(path, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body)
  });
  if (!res.ok || !res.body) {
    const data = (await res.json().catch(() => ({}))) as { error?: { message?: string } };
    throw new ApiError(data.error?.message ?? "流式请求失败", "stream_error", res.status);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop() ?? "";
    for (const event of events) {
      const line = event
        .split("\n")
        .map((item) => item.trim())
        .find((item) => item.startsWith("data:"));
      if (!line) continue;
      const payload = JSON.parse(line.slice(5).trim()) as { type: string; content?: string; message?: string };
      if (payload.type === "delta" && payload.content) handlers.onDelta(payload.content);
      if (payload.type === "done") handlers.onDone();
      if (payload.type === "error") handlers.onError(payload.message ?? "生成中断");
    }
  }
}
